import React from "react";
import './Mobile App Development.css';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
// import Slide1  from "./Images/App1.png";
import {
    FaMobileAlt,
    FaRocket,
    FaLock,
    FaCogs,
    FaSync,
    FaUserAlt
} from "react-icons/fa";
import {
    SiFlutter,
    SiReact,
    SiAndroid,
    SiApple,
    SiFirebase,
    SiMysql
} from "react-icons/si";




const MobileAppDevelopment = () => {

    const navigate = useNavigate();
    return (
        <div className="mobileapp-container">

            <Helmet>
  <title>Mobile App Development - APTech Solution</title>
  <meta
    name="description"
    content="APTech Solution creates custom iOS, Android, and cross-platform mobile applications with user-friendly designs and scalable architecture."
  />
</Helmet>

            {/* Hero Section */}
            <section className="mobileapp-hero-section">
                <h1>Mobile App Development</h1>
                <p>We build fast, secure, and scalable mobile apps tailored to your business needs.</p>
                <img src="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExMGQ4NTB1Ym5vZmhjY2dvMmlldjhvZ3Zqamw4dW9zY2Uzenl6YXR2MiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/MarRSACy8q3MPtXKQq/giphy.gif" alt="Mobile app development banner" />
            </section>



            {/* By Platform Section */}
            <section className="mobileapp-platform-section">
                <h2>Mobile Apps</h2>
                <div className="mobileapp-platform-grid">
                    <div
                        className="mobileapp-platform-card"
                        onClick={() => navigate('/IOSAppDevelopment')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>iOS Apps</h3> <br />
                        <small>Runs only on Apple devices (iPhone/iPad)</small>
                    </div>

                    <div
                        className="mobileapp-platform-card"
                        onClick={() => navigate('/AndroidAppDevelopment')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>Android Apps</h3> <br />
                        <small>Runs only on Android devices</small>
                    </div>

                    <div
                        className="mobileapp-platform-card"
                        onClick={() => navigate('/CrossPlatformAppDevelopment')}
                        style={{ cursor: 'pointer' }}
                    >
                        <h3>Cross-Platform Apps</h3>  <br />
                        <small>Runs on both iOS and Android devices</small>
                    </div>
                </div>
            </section>



            {/* App Types Section */}
            <section className="mobileapp-app-types">
                <h2>Types of Apps We Build</h2>
                <div className="mobileapp-types-grid">
                   
                    <div className="mobileapp-highlight-card bottom-border-card"> <h6>E-commerce Apps</h6> <br /><small>(e.g., Amazon, Flipkart)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>Educational Apps</h6> <br /><small>(e.g., Duolingo, BYJU’S)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"> <h6>Social Media Apps</h6> <br /><small>(e.g., Instagram, Twitter)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>Healthcare Apps</h6></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>Entertainment Apps</h6> <br /><small>(e.g., Netflix, Spotify)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>On-Demand Apps</h6> <br /><small>(e.g., Uber, Zomato)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>Health & Fitness Apps</h6> <br /><small>(e.g., MyFitnessPal)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>Finance Apps</h6> <br /><small>(e.g., Paytm, PhonePe)</small></div>
                   
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>Enterprise Apps</h6><br /><small>(for internal business use)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>News/Media Apps</h6> <br /><small>(e.g., Inshorts)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>Utility Apps</h6><br /><small>(e.g., Calculator, File Manager)</small></div>
                    <div className="mobileapp-highlight-card bottom-border-card"><h6>Productivity Apps</h6> <br /><small>(e.g., Notion, Trello)</small></div>
                </div>
            </section>


            {/* Why Choose Us */}
            <section className="mobileapp-why-choose-us">
                <h2>Why Choose Us?</h2>
            </section>

            {/* Highlights */}
            <section className="mobileapp-highlights">
                <div className="mobileapp-highlight-card gradient-border-card">
                    <FaMobileAlt />
                    <h3>Cross-Platform Development</h3>
                    <p>Build once, run on both Android and iOS efficiently.</p>
                </div>
                <div className="mobileapp-highlight-card gradient-border-card">
                    <FaRocket />
                    <h3>High Performance</h3>
                    <p>Optimized apps with smooth transitions and fast load time.</p>
                </div>
                <div className="mobileapp-highlight-card gradient-border-card">
                    <FaLock />
                    <h3>Top-notch Security</h3>
                    <p>Robust protection with encrypted databases and secure APIs.</p>
                </div>
                <div className="mobileapp-highlight-card gradient-border-card">
                    <FaCogs />
                    <h3>Custom Features</h3>
                    <p>Tailor-made features to match your unique business model.</p>
                </div>
                <div className="mobileapp-highlight-card gradient-border-card">
                    <FaSync />
                    <h3>Real-Time Sync</h3>
                    <p>Live updates and smooth data synchronization.</p>
                </div>
                <div className="mobileapp-highlight-card gradient-border-card">
                    <FaUserAlt />
                    <h3>User-Centric Design</h3>
                    <p>Intuitive UI that enhances user engagement and retention.</p>
                </div>
            </section>

            {/* Development Process */}
            <section className="mobileapp-process-section">
                <h2>Our Development Process</h2>
                <div className="mobileapp-process-steps">
                    <div className="process-step">
                        <span className="step-number">1</span>
                        <p><strong>Discovery:</strong> We begin by understanding your business goals, target users, and project scope to set a clear direction for the app.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number">2</span>
                        <p><strong>Design:</strong> Our team creates wireframes and UI/UX prototypes that focus on usability, visual appeal, and brand consistency.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number">3</span>
                        <p><strong>Development:</strong> We build the frontend and backend using modern technologies, ensuring the app is fast, secure, and fully functional.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number">4</span>
                        <p><strong>Testing:</strong> The app is rigorously tested for bugs, performance, and compatibility across devices to ensure a smooth experience.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number">5</span>
                        <p><strong>Deployment:</strong> We manage the app store submission process and ensure a successful launch on iOS and/or Android platforms.</p>
                    </div>
                    <div className="process-step">
                        <span className="step-number">6</span>
                        <p><strong>Support:</strong> After launch, we provide updates, monitor performance, and make improvements to keep your app running smoothly.</p>
                    </div>
                </div>
            </section>


            {/* Tech Stack */}
            <section className="mobileapp-tech-stack">
                <h2>Technologies We Use</h2>
                <div className="mobileapp-tech-icons">
                    <SiFlutter title="Flutter" />
                    <SiReact title="React Native" />
                    <SiAndroid title="Android" />
                    <SiApple title="iOS" />
                    <SiFirebase title="Firebase" />
                    <SiMysql title="MySQL" />
                </div>
            </section>

            {/* CTA */}
            <section >
                <div className="mobileapp-cta-section">
                <h2>Have a Mobile App Idea?</h2>
                <p>Let’s build a stunning mobile experience together.</p>
                    <Link to="/contact" state={{ scrollTo: "form" }}>
                        <button className="mobileapp-cta-button">Get a Free Quote</button>
                    </Link>
               
                </div>
            </section>
        </div>
    );
};

export default MobileAppDevelopment;
